import { toaster as rsuiteToaster, Message } from 'rsuite';
import { RSUITE_ALERT_DURATION } from '@/constants';
export const toaster = {
  success: (message, duration = RSUITE_ALERT_DURATION.DEFAULT) => {
    rsuiteToaster.push(
      <Message type="success" showIcon closable>
        {message}
      </Message>,
      {
        duration,
      }
    );
  },
  error: (message, duration = RSUITE_ALERT_DURATION.DEFAULT) => {
    rsuiteToaster.push(
      <Message type="error" showIcon closable>
        {message}
      </Message>,
      {
        duration,
      }
    );
  },
  warning: (message, duration = RSUITE_ALERT_DURATION.DEFAULT) => {
    rsuiteToaster.push(
      <Message type="warning" showIcon closable>
        {message}
      </Message>,
      {
        duration,
      }
    );
  },
  info: (message, duration = RSUITE_ALERT_DURATION.DEFAULT) => {
    rsuiteToaster.push(
      <Message type="info" showIcon closable>
        {message}
      </Message>,
      {
        duration,
      }
    );
  },
  push: (...args) => {
    rsuiteToaster.push(...args);
  },
};
